/** Hover spotlight + keyboard focus for the capabilities list. */
export function bindCapabilitiesList(nav: HTMLElement | null): () => void {
  if (!nav) return () => undefined;

  const spotlight = nav.querySelector<HTMLElement>('.capabilities-spotlight');
  const items = nav.querySelectorAll<HTMLLIElement>('li');
  if (!spotlight || items.length === 0) return () => undefined;

  let active: HTMLLIElement | null = null;

  const show = (li: HTMLLIElement): void => {
    if (active === li) return;
    active?.classList.remove('is-active');
    active = li;
    li.classList.add('is-active');
    spotlight.textContent = li.textContent?.trim() ?? '';
    nav.classList.add('has-active-item');
  };

  const clear = (): void => {
    active?.classList.remove('is-active');
    active = null;
    spotlight.textContent = '\u00a0';
    nav.classList.remove('has-active-item');
  };

  const onEnter = (e: Event): void => {
    show(e.currentTarget as HTMLLIElement);
  };

  const onFocusOut = (e: FocusEvent): void => {
    const next = e.relatedTarget;
    if (next instanceof Node && nav.contains(next)) return;
    clear();
  };

  items.forEach((li) => {
    li.tabIndex = 0;
    li.addEventListener('mouseenter', onEnter);
    li.addEventListener('focus', onEnter);
  });

  nav.addEventListener('mouseleave', clear);
  nav.addEventListener('focusout', onFocusOut);

  return () => {
    items.forEach((li) => {
      li.removeEventListener('mouseenter', onEnter);
      li.removeEventListener('focus', onEnter);
      li.removeAttribute('tabindex');
      li.classList.remove('is-active');
    });
    nav.removeEventListener('mouseleave', clear);
    nav.removeEventListener('focusout', onFocusOut);
    clear();
  };
}
